import React, { useState, useEffect } from 'react';

const LIMITES_POR_CARGO = {
  suprema_corte: { mujeres: 5, hombres: 4 },
  tribunal_disciplina: { mujeres: 3, hombres: 2 },
  tribunal_electoral: { mujeres: 1, hombres: 1 },
};
const CARGO_PLAYERA = {
  suprema_corte: 'Playera_SCJN.webp',
  tribunal_electoral: 'Playera_SSTE.webp',
  tribunal_disciplina: 'Playera_TDJ.webp',
};
const CARGO_COLOR = {
  suprema_corte: '#8683cf',
  tribunal_electoral: '#3f7f99',
  tribunal_disciplina: '#85c9bd',
};
function getPlayeraImg(canchaKey) {
  return `/assets/img/${CARGO_PLAYERA[canchaKey] || 'Playera_JD.webp'}`;
}

function ListadoCandidatos({ onSeleccionCandidatos, canchaSeleccionada, onAtras, seleccion }) {
  const [candidatos, setCandidatos] = useState([]);
  const [seleccionLocal, setSeleccionLocal] = useState(seleccion || []);
  const [mostrarCortinilla, setMostrarCortinilla] = useState(false);
  const [candidatoSeleccionado, setCandidatoSeleccionado] = useState(null);
  const [flashContador, setFlashContador] = useState({ 
    mujeres: { activo: false, tipo: 'seleccion' }, 
    hombres: { activo: false, tipo: 'seleccion' } 
  });

  useEffect(() => {
    setSeleccionLocal(seleccion || []);
  }, [seleccion, canchaSeleccionada]);

  useEffect(() => {
    async function fetchCandidatos() {
      let archivo = `/assets/json/${canchaSeleccionada}.json`;
      let lista = [];
      try {
        const res = await fetch(archivo);
        lista = await res.json();
      } catch (e) {
        lista = [];
      }
      setCandidatos(lista);
    }
    fetchCandidatos();
  }, [canchaSeleccionada]);

  const limites = LIMITES_POR_CARGO[canchaSeleccionada] || { mujeres: 5, hombres: 5 };

  const handleToggle = (candidato) => {
    const yaSeleccionado = seleccionLocal.find((c) => c.ID_UNICO === candidato.ID_UNICO);
    if (yaSeleccionado) {
      setSeleccionLocal(seleccionLocal.filter((c) => c.ID_UNICO !== candidato.ID_UNICO));
      // Flash rojo para deselección
      setFlashContador({
        mujeres: { 
          activo: candidato.SEXO === 'MUJER', 
          tipo: 'deseleccion' 
        },
        hombres: { 
          activo: candidato.SEXO === 'HOMBRE', 
          tipo: 'deseleccion' 
        }
      });
    } else {
      const mujeres =
        seleccionLocal.filter((c) => c.SEXO === 'MUJER').length +
        (candidato.SEXO === 'MUJER' ? 1 : 0);
      const hombres =
        seleccionLocal.filter((c) => c.SEXO === 'HOMBRE').length +
        (candidato.SEXO === 'HOMBRE' ? 1 : 0);
      if (
        (candidato.SEXO === 'MUJER' && mujeres > limites.mujeres) ||
        (candidato.SEXO === 'HOMBRE' && hombres > limites.hombres)
      ) {
        alert(`Límite de selección alcanzado para ${candidato.SEXO === 'MUJER' ? 'mujeres' : 'hombres'} (${candidato.SEXO === 'MUJER' ? limites.mujeres : limites.hombres})`);
        return;
      }
      setSeleccionLocal([...seleccionLocal, candidato]);
      
      // Flash verde para selección
      setFlashContador({
        mujeres: { 
          activo: candidato.SEXO === 'MUJER', 
          tipo: 'seleccion' 
        },
        hombres: { 
          activo: candidato.SEXO === 'HOMBRE', 
          tipo: 'seleccion' 
        }
      });
    }
    
    // Desactivar el flash después de 500ms
    setTimeout(() => {
      setFlashContador({ 
        mujeres: { activo: false, tipo: 'seleccion' }, 
        hombres: { activo: false, tipo: 'seleccion' } 
      });
    }, 500);
  };

  const handleContinuar = () => {
    onSeleccionCandidatos(seleccionLocal);
  };

  const handleAbrirCortinilla = (candidato) => {
    setCandidatoSeleccionado(candidato);
    setMostrarCortinilla(true);
  };

  const handleCerrarCortinilla = () => {
    setMostrarCortinilla(false);
    setCandidatoSeleccionado(null);
  };

  const mujeres = candidatos.filter(c => c.SEXO === 'MUJER');
  const hombres = candidatos.filter(c => c.SEXO === 'HOMBRE');
  const mujeresSeleccionadas = seleccionLocal.filter((c) => c.SEXO === 'MUJER').length;
  const hombresSeleccionados = seleccionLocal.filter((c) => c.SEXO === 'HOMBRE').length;
  const cargoColor = CARGO_COLOR[canchaSeleccionada] || '#3a5a40';
  const mostrarConfirmar = seleccionLocal.length > 0;

  return (
    <div className="listado-candidatos pantalla-playeras">
      {mostrarCortinilla && candidatoSeleccionado && (
        <div className="cortinilla-conocelo">
          <div className="cortinilla-contenido">
            <h3>Conócelo</h3>
            <div className="info-candidato">
              {/* Poder Postulante */}
              <div className="info-item info-item-destacado">
                <strong>¿Quién le postula?</strong>
                <div>{candidatoSeleccionado.PODER_POSTULA}</div>
              </div>

              {/* Contacto en dos columnas */}
              <div className="info-item info-item-columnas">
                <div className="columna">
                  <strong>Teléfono</strong>
                  <div>{candidatoSeleccionado.TELEFONO}</div>
                </div>
                <div className="columna">
                  <strong>Correo Electrónico</strong>
                  <div>{candidatoSeleccionado.CORREO_ELECTRONICO}</div>
                </div>
              </div>

              {/* Educación en dos columnas */}
              <div className="info-item info-item-columnas">
                <div className="columna">
                  <strong>Escolaridad</strong>
                  <div>{candidatoSeleccionado.ESCOLARIDAD}</div>
                </div>
                <div className="columna">
                  <strong>Trayectoria Académica</strong>
                  <div>{candidatoSeleccionado.TRAYECTORIA_ACADEMICA}</div>
                </div>
              </div>

              {/* Resto de la información */}
              {Object.entries(candidatoSeleccionado).map(([key, value]) => {
                const camposExcluidos = [
                  'ID_UNICO',
                  'CURRICULUM_VITAE',
                  'ESTATUS',
                  'NOMBRE_CANDIDATO',
                  'CARGO',
                  'ENTIDAD',
                  'NUM_LISTA_EN_BOLETA',
                  'SEXO',
                  'ESTATUS_ESCOLARIDAD',
                  'PODER_POSTULA',
                  'TELEFONO',
                  'CORREO_ELECTRONICO',
                  'ESCOLARIDAD',
                  'TRAYECTORIA_ACADEMICA',
                  'PAGINA_WEB',
                  'REDES'
                ];
                if (!camposExcluidos.includes(key)) {
                  return (
                    <div key={key} className="info-item">
                      <strong>{key.replace(/_/g, ' ')}:</strong> {value}
                    </div>
                  );
                }
                return null;
              })}

              {/* Redes sociales al final */}
              {candidatoSeleccionado.REDES && (
                <div className="info-item info-item-redes">
                  <strong>Redes Sociales</strong>
                  <div>{candidatoSeleccionado.REDES}</div>
                </div>
              )}
            </div>
            <button 
              className="btn-cerrar"
              onClick={handleCerrarCortinilla}
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
      <button
        className="boton-cargo-flotante"
        style={{ background: cargoColor }}
        tabIndex={-1}
        aria-label={canchaSeleccionada}
        type="button"
      >
        {canchaSeleccionada.replace(/_/g, ' ').toUpperCase()}
      </button>
      <div className="contadores-genero">
        <div className={`contador-genero-mujer ${flashContador.mujeres.activo ? `flash-${flashContador.mujeres.tipo}` : ''}`}>
          Elije: {mujeresSeleccionadas}/{limites.mujeres} mujeres
        </div>
        <div className={`contador-genero-hombre ${flashContador.hombres.activo ? `flash-${flashContador.hombres.tipo}` : ''}`}>
          Elije: {hombresSeleccionados}/{limites.hombres} hombres
        </div>
      </div>
      {mostrarConfirmar && (
        <button
          className="boton-flotante-confirmar"
          onClick={handleContinuar}
          type="button"
        >
          Confirmar
        </button>
      )}
      <button
        className="boton-flotante-atras"
        onClick={onAtras}
        type="button"
        style={{ 
          padding: '12px 28px',
          fontSize: '1.1rem',
          width: '50%',
          maxWidth: '240px'
        }}
      >
        <span className="icono-flecha-izq" aria-hidden="true" style={{ marginRight: 4, display: 'inline-block', verticalAlign: 'middle' }}>
          <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 18L8 11L14 4" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
        Menú Principal
      </button>
      <h2>Selecciona tus candidatos</h2>
      <div className="playeras-grid">
        <div className="columna-candidatos">
          <h3>Mujeres</h3>
          {mujeres.length === 0 && <div className="sin-candidatos">No hay candidatas.</div>}
          {mujeres.map((c) => (
            <div key={c.ID_UNICO} className={`playera-candidato-doble ${seleccionLocal.find((s) => s.ID_UNICO === c.ID_UNICO) ? 'seleccionado' : ''}`}> 
              <button
                className="btn-playera"
                type="button"
                onClick={() => handleToggle(c)}
                aria-pressed={!!seleccionLocal.find((s) => s.ID_UNICO === c.ID_UNICO)}
              >
                <div className="playera-img-wrapper">
                  <img src={getPlayeraImg(canchaSeleccionada)} alt="Playera" className="playera-img" />
                  <span className="numero-boleta">{c.NUM_LISTA_EN_BOLETA}</span>
                </div>
              </button>
              <button
                className="btn-nombre"
                type="button"
                onClick={() => handleAbrirCortinilla(c)}
                style={{ cursor: 'pointer' }}
              >
                <div className="nombre-candidato">{c.NOMBRE_CANDIDATO}</div>
              </button>
            </div>
          ))}
        </div>
        <div className="columna-candidatos">
          <h3>Hombres</h3>
          {hombres.length === 0 && <div className="sin-candidatos">No hay candidatos.</div>}
          {hombres.map((c) => (
            <div key={c.ID_UNICO} className={`playera-candidato-doble ${seleccionLocal.find((s) => s.ID_UNICO === c.ID_UNICO) ? 'seleccionado' : ''}`}> 
              <button
                className="btn-playera"
                type="button"
                onClick={() => handleToggle(c)}
                aria-pressed={!!seleccionLocal.find((s) => s.ID_UNICO === c.ID_UNICO)}
              >
                <div className="playera-img-wrapper">
                  <img src={getPlayeraImg(canchaSeleccionada)} alt="Playera" className="playera-img" />
                  <span className="numero-boleta">{c.NUM_LISTA_EN_BOLETA}</span>
                </div>
              </button>
              <button
                className="btn-nombre"
                type="button"
                onClick={() => handleAbrirCortinilla(c)}
                style={{ cursor: 'pointer' }}
              >
                <div className="nombre-candidato">{c.NOMBRE_CANDIDATO}</div>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ListadoCandidatos; 